<template>
  <card :padding="24" dis-hover class="profile-block-card change-password">
    <div class="card-header large">
      <div class="card-header__title">
        <icon class="ms-help" size="16" type="md-key"></icon>
        <span class="ms-help card-header__title-text">Изменить пароль</span>
      </div>
    </div>
    <div class="change-password__container">
      <i-form
        ref="changePasswordForm"
        :model="currentInfo"
        label-position="left"
        :label-width="160"
      >
        <form-item label="Старый пароль" prop="last_name">
          <i-input
            type="password"
            size="default"
            v-model="currentInfo.old_password"
          />
        </form-item>
        <form-item label="Новый пароль" prop="first_name">
          <i-input
            type="password"
            size="default"
            v-model="currentInfo.new_password"
          />
        </form-item>
        <form-item label="Повторите новый пароль" prop="middle_name">
          <i-input
            type="password"
            size="default"
            v-model="currentInfo.new_password_repeat"
          />
        </form-item>
        <form-item>
          <i-button
            size="default"
            type="primary"
            @click="changePassword"
            :disabled="isDisabled"
            :loading="loading"
            >Изменить пароль</i-button
          >
        </form-item>
      </i-form>
    </div>
  </card>
</template>

<script>
export default {
  data () {
    return {
      currentInfo: {
        old_password: '',
        new_password: '',
        new_password_repeat: ''
      },
      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    },
    isDisabled () {
      return Object.keys(this.currentInfo).some(f => !this.currentInfo[f])
    }
  },
  methods: {
    async changePassword () {
      const { new_password, new_password_repeat } = this.currentInfo
      if (new_password !== new_password_repeat) {
        this.$Message.error('Пароли должны совпадать')
        return
      }

      try {
        this.loading = true
        const url = `objectInfo/users`
        const data = { id: this.user.id, password: new_password }
        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.$Message.success('Пароль успешно изменен')
        this.currentInfo.old_password = ''
        this.currentInfo.new_password = ''
        this.currentInfo.new_password_repeat = ''
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.$Message.error('При изменении пароля произошла ошибка')
      }
    }
  }
}
</script>

<style lang="less">
.change-password {
  .ivu-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>
